module.exports = __webpack_public_path__ + "img/3ea6beec64369c2642b92c6726f1epng.6ce249bd.png";